export default __webpack_public_path__ + "static/media/cross.44c06867.png";